<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h2>รายงานการสั่งซื้อ</h2>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.order_code}}</td>
                        <td>{{dataDetail.item.customer_name}}</td>
                        <td>{{dataDetail.item.total_price}}</td>
                        <td>{{dataDetail.item.created_at}}</td>
                        <td>{{dataDetail.item.track_number}}</td>
                        <td>
                            <span class="cursor_content_retrospect_list" @click="retrospectDetail(dataDetail.item.id)">
                                <v-icon right color="grey">mdi-eye</v-icon>
                            </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </div>
</div>
</template>

<script>
import contentretrospect from '@/api/content/contentpurchase/contentretrospect.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            search: '',
            headers: [{
                    text: 'รหัสคำสั่งซื้อ',
                    align: 'start',
                    value: 'order_code',
                },
                {
                    text: 'ลูกค้า',
                    value: 'customer_name'
                },
                {
                    text: 'ยอดรวม',
                    value: 'total_price'
                },
                {
                    text: 'วันที่สั่งซื้อ',
                    value: 'created_at'
                },
                {
                    text: 'เลขแทร็กกิ้ง',
                    value: 'track_number'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async retrospectList() {
            this.loading_page = true
            this.data = []
            contentretrospect.retrospectList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.orders
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async retrospectDetail(id) {
            const idPage = {
                id: id
            }
            this.$store.commit('detailContentRetrospectPage', idPage)
            this.$router.push('/contentorderdetail/orderretrospect')
        }
    },
    mounted() {
        this.retrospectList()
    }
}
</script>

<style scoped>
.cursor_content_retrospect_list {
    cursor: pointer;
}
</style>
